import { isPlatformOpsUser } from "../components/platform-broadcast/constants";

/**
 * True in local/dev builds (Create React App / webpack NODE_ENV).
 */
export function isDevEnvironment() {
  return process.env.NODE_ENV === "development";
}

/**
 * Platform ops email or company role `admin` (same “super admin” pattern as absence_form).
 * @param {{ email?: string, roles?: Array<{ name?: string }> } | null | undefined} currentUser
 */
export function isSuperAdminUser(currentUser) {
  if (!currentUser) return false;
  if (isPlatformOpsUser(currentUser.email)) return true;
  return Boolean(currentUser.roles?.some((r) => r?.name === "admin"));
}

/**
 * Internal/developer copy (ADR, Cursor, AGENTS.md, …) may only show in DEV or for super admin.
 * @param {{ email?: string, roles?: Array<{ name?: string }> } | null | undefined} currentUser
 */
export function isDevOrSuperAdmin(currentUser) {
  return isDevEnvironment() || isSuperAdminUser(currentUser);
}
